import { useContextNavigate } from "../../../../hooks/navigate";
import { ActionPromptType } from "../../../../hooks/prompts";
import { TaskContext } from "../../TasksTypes";
import { TaskTypeBlock } from "../../TaskTypeBlock";
import addHomescreenIcon from "./icons/add-icon.png";

export const AddToHomeScreenBlock = () => {
    const navigate = useContextNavigate<TaskContext>();

    return (
        <TaskTypeBlock
            handler={ () => navigate(TaskContext.HomeScreenShortcur) }
            name={ <span>Добавить иконку<br />на главный экран</span> }
            icon={ addHomescreenIcon }
            description={ '' }
            iconTypeStyle='iconTypeHomescreen'
            promptType={ ActionPromptType.PLACE_ICON_ADD }
        />
    );
}